import { Outlet } from "react-router";
import { Center, Container, VStack, HStack, Box } from "@chakra-ui/react";
import LogoImg from '../assets/logo.png'
import React, {useContext} from "react";
import {Context} from "../store";

/** TODO: Remove HARD CODE */
const essentai = 'https://acaamdmguo.cloudimg.io/v7/zumdex.ams3.digitaloceanspaces.com/public/images/branches/95/8f/96/83/0b/9c/11/f0/93/14/02/fa/71/bd/25/3f/original'
const shetel = 'https://acaamdmguo.cloudimg.io/v7/zumdex.ams3.digitaloceanspaces.com/public/images/branches/53/fc/5c/ae/32/0e/11/f0/8c/69/de/f9/fb/c0/9b/1a/original'

const Layout = () => {
  const { branch_id, phone, user, changeStore } = useContext(Context)
  let img = LogoImg

  switch (branch_id) {
    case '1893930068799918080':
      img = essentai
      break
    case '1893933268588302336':
      img = shetel
      break
  }

  return (
    <Container>
      <Center>
        <VStack height="100vh" width="sm">
          <Box
            marginTop={10}
          >
            <img
              src={img}
              style={{ maxHeight: 100, maxWidth: '100%' }}
              alt="pass.sagi.kz"
            />
          </Box>
          <HStack paddingTop={5} justifyContent="center" width="100%">
            <Outlet />
          </HStack>
        </VStack>
      </Center>

    </Container>
  )
}

export default Layout